import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { GroupForm, UpdateGroupFormData } from './GroupForm';
import { Group, UpdateGroupDto } from '@/lib/api/groups';

export interface UpdateGroupModalProps extends BaseModalProps {
  group: Group;
  onUpdate: (id: string, data: UpdateGroupDto) => Promise<boolean>;
  isUpdating: boolean;
}

export function UpdateGroupModal({
  open,
  onOpenChange,
  group,
  onUpdate,
  isUpdating,
}: UpdateGroupModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: UpdateGroupFormData) => {
    const success = await onUpdate(group.id, {
      name: data.name,
      description: data.description,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t('groups.updateModal.title', 'Editar Equipe')}
    >
      <GroupForm
        mode="update"
        onSubmit={handleSubmit}
        isLoading={isUpdating}
        initialData={{
          name: group.name,
          description: group.description,
        }}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
